const Style = {
  row: 'overflow-auto mb-4',
  title: 'float-left mt-2 font-semibold text-lg',
  actions: 'float-right',
}

export default Style
